import { lazy } from "react";

// route
export const reportRoute = { path: "/report", name: "menu.report", icon: "content_paste" };
export const rProductPriceValueRoute = { path: `${reportRoute.path}/productPriceValue`, name: "Nilai Harga Produk" };
export const rPurchaseAnalysisRoute = { path: `${reportRoute.path}/purchaseAnalysis`, name: "Analisis Pembelian" };
export const rSellingInvoiceRoute = { path: `${reportRoute.path}/inv_out`, name: "Penjualan" };
export const rSellingInvoiceDetailRoute = { path: `${reportRoute.path}/inv_out_detail`, name: "Detail Penjualan" };
export const rPurchInvoiceRoute = { path: `${reportRoute.path}/purchaseInvoice`, name: "Pembelian" };
export const rDORoute = { path: `${reportRoute.path}/do`, name: "Delivery Order" };
export const rDODetailRoute = { path: `${reportRoute.path}/do_detail`, name: "Detail Delivery Order" };
export const rSORoute = { path: `${reportRoute.path}/so`, name: "Sales Order" };
export const rSODetailRoute = { path: `${reportRoute.path}/so_detail`, name: "Detail Sales Order" };
export const rReturnCustomerRoute = { path: `${reportRoute.path}/return_customer`, name: "common_report.return_cus." };
export const rReturnSupplierRoute = { path: `${reportRoute.path}/return_supplier`, name: "common_report.return_sup." };
export const rSalesCommissionRoute = { path: `${reportRoute.path}/sales_commission`, name: "common_report.sales_commission." };

// component
const Report = lazy(() => import("../page/report/Report"));
const RProductPriceValue = lazy(() => import("../page/report/product_price_value/ReportProductPriceValue"));
const RSellingInvoice = lazy(() => import("../page/report/selling_invoice/ReportSellingInvoice"));
const RSellingInvoiceDetail = lazy(() => import("../page/report/selling_invoice/ReportSellingInvoiceDetail"));
const RPurchaseInvoice = lazy(() => import("../page/report/purchase_invoice/ReportPurchaseInvoice"));
const RDO = lazy(() => import("../page/report/do/ReportDO"));
const RDODetail = lazy(() => import("../page/report/do/ReportDODetail"));
const RSO = lazy(() => import("../page/report/so/ReportSO"));
const RSODetail = lazy(() => import("../page/report/so/ReportSODetail"));
const RReturnCustomer = lazy(() => import("../page/report/return_customer/ReportReturnCustomer"));
const RReturnSupplier = lazy(() => import("../page/report/return_supplier/ReportReturnSupplier"));
const RSalesCommission = lazy(() => import("../page/report/commission/ReportSalesCommission"));

export const reportListRoutes = [
    // rProductPriceValueRoute,
    // rPurchaseAnalysisRoute,
    rSellingInvoiceRoute, rSellingInvoiceDetailRoute,
    rPurchInvoiceRoute,
    rDORoute, rDODetailRoute,
    rSORoute, rSODetailRoute,
    rReturnCustomerRoute,
    rReturnSupplierRoute,
    rSalesCommissionRoute,
];

export const reportRoutes = {
    element: <Report />,
    children: [
        { ...rProductPriceValueRoute, element: <RProductPriceValue /> },
        // { ...rPurchaseAnalysisRoute, element: <></> },
        { ...rSellingInvoiceRoute, element: <RSellingInvoice /> },
        { ...rSellingInvoiceDetailRoute, element: <RSellingInvoiceDetail /> },
        { ...rPurchInvoiceRoute, element: <RPurchaseInvoice /> },
        { ...rDORoute, element: <RDO /> },
        { ...rDODetailRoute, element: <RDODetail /> },
        { ...rSORoute, element: <RSO /> },
        { ...rSODetailRoute, element: <RSODetail /> },
        { ...rReturnCustomerRoute, element: <RReturnCustomer /> },
        { ...rReturnSupplierRoute, element: <RReturnSupplier /> },
        { ...rSalesCommissionRoute, element: <RSalesCommission /> },
    ],
};
